import { render } from "./BookingRulesPage.vue?vue&type=template&id=278ec411"
import script from "./BookingRulesPage.vue?vue&type=script&lang=js"
export * from "./BookingRulesPage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__